/** Permission keys (`module.action`) — SAGOT_BUILD_PROMPT_v1.md §7.3. */
export const PERMISSION_KEYS = [
  "workspace.view",
  "workspace.manage",
  "workspace.delete",
  "agents.view",
  "agents.create",
  "agents.edit",
  "agents.delete",
  "agents.publish",
  "playground.use",
  "knowledge.view",
  "knowledge.create",
  "knowledge.edit",
  "knowledge.delete",
  "knowledge.reindex",
  "actions.view",
  "actions.manage",
  "workflows.view",
  "workflows.manage",
  "workflows.publish",
  "evaluations.view",
  "evaluations.run",
  "evaluations.manage",
  "widget.view",
  "widget.manage",
  "channels.view",
  "channels.manage",
  "inbox.view",
  "inbox.reply",
  "inbox.takeover",
  "inbox.assign",
  "inbox.export",
  "leads.view",
  "leads.edit",
  "leads.export",
  "gaps.view",
  "gaps.resolve",
  "announcements.view",
  "announcements.create",
  "announcements.send",
  "analytics.view",
  "analytics.export",
  "audiences.view",
  "audiences.manage",
  "team.view",
  "team.invite",
  "team.manage",
  "roles.manage",
  "billing.view",
  "billing.manage",
  "settings.view",
  "settings.manage",
  "api_keys.manage",
  "webhooks.manage",
  "integrations.manage",
  "audit.view",
  "data.export",
  // Service Desk (M27, migrations 0053 and 0073).
  "tickets.view",
  "tickets.reply",
  "tickets.note",
  "tickets.assign",
  "tickets.manage",
  "tickets.delete",
  "tickets.configure",
  "tickets.reports",
  "tickets.export",
  "organisations.view",
  "organisations.manage",
  "organisations.export",
  "assets.view",
  "assets.manage",
  "visits.view",
  "visits.manage",
  "visits.perform",
  "orders.view",
  "orders.manage",
  "orders.approve",
  "orders.export",
  "connectors.manage",
  "connectors.view",
  "connectors.test",
  "connectors.invoke",
  // Secure chat (M29, migrations 0100 and 0104): Owner and Admin only.
  "customers.view_reference",
  "customers.manage_launch",
  "workflows.publish_override",
  // Live-chat ops (M29 P2, migration 0106): wallboard.view also for Viewer (every *.view key).
  "wallboard.view",
  "routing.manage_live",
] as const;

export type PermissionKey = (typeof PERMISSION_KEYS)[number];

const PERMISSION_SET: ReadonlySet<string> = new Set(PERMISSION_KEYS);

export function isPermissionKey(value: string): value is PermissionKey {
  return PERMISSION_SET.has(value);
}

export const BUILT_IN_ROLES = ["owner", "admin", "editor", "agent", "viewer", "field_engineer", "sales"] as const;
export type BuiltInRole = (typeof BUILT_IN_ROLES)[number];

/** Platform staff roles (backend `PlatformStaffRoleKey`). */
export const PLATFORM_ROLES = ["super_admin", "platform_engineer", "sales_billing", "support_agent", "qa"] as const;
export type PlatformRole = (typeof PLATFORM_ROLES)[number];
